module.exports = __webpack_public_path__ + "img/prosePlaceHolder.73163e29.jpg";